module.exports = __webpack_public_path__ + "static/partnerships-1-3ff9af67d063d5301cad61d970509879.jpg";